import React, { useEffect, useRef } from "react";
import JumboLayoutProvider from "@jumbo/components/JumboLayout/JumboLayoutProvider";
import JumboContentLayoutProvider from "@jumbo/components/JumboContentLayout/JumboContentLayoutProvider";
import useJumboApp from "@jumbo/hooks/useJumboApp";
import { LAYOUTS } from "./utils/constants/layouts";
import { config } from "./config/main";
import useJumboAuth from "@jumbo/hooks/useJumboAuth";
//import { useJumboLayoutSidebar, useJumboSidebarTheme } from "@jumbo/hooks";
// import { sidebarTheme as theme1 } from "./themes/sidebar/theme1";
// import { sidebarTheme as defaultTheme } from "./themes/sidebar/default";
// import { sidebarTheme as darkTheme } from "./themes/sidebar/dark";

import {
  useJumboFooterTheme,
  useJumboHeaderTheme,
  useJumboLayoutHeader,
  useJumboLayoutSidebar,
  useJumboSidebarTheme,
  useJumboTheme,
} from "@jumbo/hooks";

import { sidebarTheme as theme1 } from "app/themes/sidebar/theme1";
import { sidebarTheme as defaultTheme } from "app/themes/sidebar/default";
import { sidebarTheme as darkTheme } from "app/themes/sidebar/dark";

import { headerTheme as headerDefaultTheme } from "app/themes/header/default";
import { headerTheme as headerTheme1 } from "app/themes/header/theme1";

import { footerTheme as footerDefaultTheme } from "app/themes/footer/default";
import { footerTheme as footerTheme1 } from "app/themes/footer/theme1";
import cloneDeep from "lodash.clonedeep";
import { useSelector } from "react-redux";

const AppLayout = (props) => {
  const { authUserTheme } = useSelector((state) => state.CommonReducer);
  const { activeLayout } = useJumboApp();
  const { isLoading } = useJumboAuth();

  if (!activeLayout) {
    throw Error("AppLayout > No activeLayout is set.");
  }

  const LayoutComponent = React.useMemo(() => {
    const layoutIndex = LAYOUTS.findIndex(
      (layout) => layout.name === activeLayout
    );

    if (layoutIndex >= 0) {
      return LAYOUTS[layoutIndex].component;
    }

    throw Error("No activeLayout is set yet.");
  }, [activeLayout]);

  // const { sidebarOptions, setSidebarOptions } = useJumboLayoutSidebar();
  // const { sidebarTheme, setSidebarTheme } = useJumboSidebarTheme();

  const { sidebarOptions, setSidebarOptions } = useJumboLayoutSidebar();
  const { sidebarTheme, setSidebarTheme } = useJumboSidebarTheme();
  const initialSidebarTheme = useRef(sidebarTheme);
  const initialSidebarOptions = useRef(sidebarOptions);

  const { headerTheme, setHeaderTheme } = useJumboHeaderTheme();
  const { headerOptions, setHeaderOptions } = useJumboLayoutHeader();
  const initialHeaderTheme = useRef(headerTheme);

  const { footerTheme, setFooterTheme } = useJumboFooterTheme();
  const { theme } = useJumboTheme();
  const initialFooterTheme = useRef(footerTheme);

  // useEffect(() => {
  //   setSidebarTheme({
  //     ...sidebarTheme,
  //     ...theme1,
  //     // palette: {background: {paper: activeBgColorOption?.color}},
  //     overlay: {
  //       // backgroundImage: `linear-gradient(${activeBgColorOption?.colors[0]}, ${activeBgColorOption?.colors[1]})`,
  //       bgColor: "red",
  //     },
  //   });
  // }, []);

  //console.log("SideBarThemein App:", sidebarTheme);

  const applyUserTheme = (themeDetails) => {
    let selOptions = themeDetails;

    let headerOptionsObj = selOptions?.header_options
      ? JSON.parse(selOptions?.header_options)
      : {};

    let sidebarOptionsObj = selOptions?.sidebar_options
      ? JSON.parse(selOptions?.sidebar_options)
      : {};

    let footerOptionsObj = selOptions?.footer_options
      ? JSON.parse(selOptions?.footer_options)
      : {};

    if (
      sidebarOptionsObj?.bg_color?.toLowerCase() != "#fff" &&
      sidebarOptionsObj?.bg_color?.toLowerCase() != "#ffffff"
    ) {
      setSidebarTheme({
        ...sidebarTheme,
        ...theme1,
        //palette: {background: {paper: activeBgColorOption?.color}},
        overlay: {
          // backgroundImage: `linear-gradient(${activeBgColorOption?.colors[0]}, ${activeBgColorOption?.colors[1]})`,
          bgColor: sidebarOptionsObj?.bg_color,
        },
      });
    }

    // setSidebarOptions({
    //   scrollType: sidebarOptionsObj?.is_sidebar_fixed ? "fixed" : "static",
    // });

    //Header Options
    let themeOption = {
      name: "theme-2",
      label: "Theme 2",
      color: headerOptionsObj?.bg_color,
      themeObject: headerTheme1,
    };
    let themeObj = cloneDeep(themeOption.themeObject);
    themeObj.components.MuiAppBar.styleOverrides.root.background =
      themeOption.color;

    if (
      themeOption?.color?.toLowerCase() != "#fff" &&
      themeOption?.color?.toLowerCase() != "#ffffff"
    ) {
      setHeaderTheme({
        ...theme,
        ...themeObj,
      });
    }

    //Header Fixed
    //setHeaderOptions({ fixed: headerOptionsObj?.is_header_fixed });

    //Footer Options
    let footerThemeOption = {
      name: "theme-2",
      label: "Theme 2",
      color: footerOptionsObj?.bg_color,
      themeObject: footerTheme1,
    };
    let footerThemeObj = cloneDeep(footerThemeOption.themeObject);
    footerThemeObj.palette.background.paper = footerThemeOption.color;
    footerThemeObj.palette.divider = footerThemeOption.color;

    if (
      footerThemeOption?.color?.toLowerCase() != "#fff" &&
      footerThemeOption?.color?.toLowerCase() != "#ffffff"
    ) {
      setFooterTheme({ ...theme, ...footerThemeObj });
    }
  };

  useEffect(() => {
    if (authUserTheme != "" && authUserTheme?.header_options) {
      applyUserTheme(authUserTheme);
    }
  }, [authUserTheme]);

  return (
    <JumboLayoutProvider>
      {isLoading ? (
        <div className="loader">
          <svg className="circular-loader" viewBox="25 25 50 50">
            <circle className="loader-path" cx="50" cy="50" r="20" />
          </svg>
        </div>
      ) : (
        <LayoutComponent>
          <JumboContentLayoutProvider
            layoutOptions={config.defaultContentLayout}
          >
            {props.children}
          </JumboContentLayoutProvider>
        </LayoutComponent>
      )}
    </JumboLayoutProvider>
  );
};

export default AppLayout;
